// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1oV9R","title":"BackImages_title__AUFvi","images":"BackImages_images__2dyzz"};